import axios from '@/axios/axios'

export default {
  namespaced: true, 
  actions:{
    requestList(context, type){
      return axios
      .get('/api/additionalItem/getList', {
        params: {
          type: type
        }
      })
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(error => {
        console.log(error)
        return Promise.reject(error)
      })
    },
    save(context, payload){
      return axios
      .post('/api/admin/additionalItem/add', {
        type: payload.type,
        list: payload.list
      })
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(error => {
        console.log(error)
        return Promise.reject(error)
      })
    }
  }
}